import * as R from 'ramda';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import useOrderBookStore from '../../../../stores/OrderBook/orderBook.store';
import useProductDetailsStore from '../../../../stores/ProductDetails/productDetails.store';
import useOrderBook from '../../../order-book/hooks/useOrderBook';

const useSyncProductDetailsOrders = () => {
  const { productGridParams, removeCopiedGrid, handleChangeProductGridParams } =
    useProductDetailsStore(
      useShallow((state) => ({
        productGridParams: state.productGridParams,
        removeCopiedGrid: state.removeCopiedGrid,
        handleChangeProductGridParams: state.handleChangeProductGridParams,
      })),
    );

  const selectedOrderId = useOrderBookStore((state) => state.selectedOrder?.id);
  const { allOrders } = useOrderBook();

  const currentOrderIds = productGridParams.orderIds ?? [];
  const isAllOrdersSelected = currentOrderIds.length > 1;

  const orderBookOrderIds = isAllOrdersSelected
    ? allOrders.map((order) => order.id)
    : [selectedOrderId].filter((orderId): orderId is string => !!orderId);

  useEffect(() => {
    if (productGridParams.isFinishedOrder || orderBookOrderIds.length === 0) {
      return;
    }

    if (R.equals(currentOrderIds, orderBookOrderIds)) {
      return;
    }

    removeCopiedGrid();
    handleChangeProductGridParams({ ...productGridParams, orderIds: orderBookOrderIds });
  }, [
    currentOrderIds,
    orderBookOrderIds,
    productGridParams,
    removeCopiedGrid,
    handleChangeProductGridParams,
  ]);
};

export default useSyncProductDetailsOrders;
